import {
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { useCalendarStore } from "../../store/useCalendarStore";
import useDrag from "../hooks/useDrag";
import DayWeekCalendar from "./DayWeekCalendar";
import MonthCalendar from "./MonthCalendar";
import { RescheduleModal } from "./RescheduleModal/RescheduleModal";
import { TimeOffDropScope } from "./TimeOffDropScope";
import { useSearchParams } from "react-router";
import { useShallow } from "zustand/react/shallow";
import { LoadingOverlay } from "@/Components/NextBase/LoadingOverlay";

const Calendar = ({
  setIsMonthCalendar,
  isFetchingTimeoffs,
  highlightedDate,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const openApptId = searchParams.get("openApptId");

  const {
    calendarData,
    calendarView,
    fetchingCalendarData,
    isRefetchingCalendarDate,
    rescheduleData,
    setSelectedAppointmentId,
  } = useCalendarStore(
    useShallow((state) => ({
      calendarData: state.calendarData,
      calendarView: state.calendarView,
      fetchingCalendarData: state.fetchingCalendarData,
      isRefetchingCalendarDate: state.isRefetchingCalendarDate,
      rescheduleData: state.rescheduleData,
      setSelectedAppointmentId: state.setSelectedAppointmentId,
    })),
  );

  const rescheduleForm = useForm({
    initialValues: {
      rescheduleAllLinked: true,
      allLinkedSameUserOrResource: false,
      sendNotifications: true,
      overrideUserService: false,
      overrideResourceService: false,
    },
  });

  const { handleDragCancel, handleDragEnd, handleDragMove, handleDragStart } =
    useDrag();

  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 10,
    },
  });

  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 300,
      tolerance: 5,
    },
  });

  const sensors = useSensors(mouseSensor, touchSensor);

  useEffect(() => {
    setIsMonthCalendar(calendarView === "month");
  }, [calendarView]);

  useEffect(() => {
    if (rescheduleData) {
      rescheduleForm.reset();
    }
  }, [rescheduleData]);

  useEffect(() => {
    if (openApptId) {
      setSelectedAppointmentId(openApptId);
      setSearchParams(
        (prev) => {
          prev.delete("openApptId");
          return prev;
        },
        {
          replace: true,
        },
      );
    }
  }, [openApptId]);

  return (
    <DndContext
      onDragEnd={handleDragEnd}
      sensors={sensors}
      onDragMove={handleDragMove}
      onDragStart={handleDragStart}
      onDragCancel={handleDragCancel}
    >
      <>
        <LoadingOverlay
          visible={
            (fetchingCalendarData || isFetchingTimeoffs) &&
            !isRefetchingCalendarDate
          }
        />

        {/* calendar for day and week view */}
        {calendarView !== "month" && calendarData?.days?.length < 10 && (
          <DayWeekCalendar highlightedDate={highlightedDate} />
        )}

        {/* calendar for month view */}
        {calendarView === "month" && calendarData?.days?.length > 10 && (
          <MonthCalendar />
        )}
      </>

      {rescheduleData ? <RescheduleModal></RescheduleModal> : null}
      <TimeOffDropScope />
    </DndContext>
  );
};

export default Calendar;
